import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CoreServiceRegistry } from '../../../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../../../shared/shared-service-registry';




@Component({
  selector: 'lfwms-img-viewer-popup',
  templateUrl: './full-view-img-viewer.component.html',
  styleUrls: ['./full-view-img-viewer.component.css']
})
export class FullViewImgViewerPopupComponent {

  @Input() public currentImgUrl: string = '';
  @Input() public imgUrlArray: Array<string> = [];
  @Input() public index: number = 0;
  @Output() public nextOrPreviousImage = new EventEmitter();
  @Output() public xButtonClicked = new EventEmitter();
  public lblPreview: string = '';
  public lblNext: string = '';
  public resourceService: any;
  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
      this.resourceService = this.coreServiceRegistry.resourceService;
      this.lblPreview = this.resourceService.get('sku_lbl_prev');
      this.lblNext = this.resourceService.get('sku_lbl_next');
     }

  /**
   * navigate To Next Or Previous Image
   */
  public navigateToNextOrPreviousImage(prevOrNext: string) {
    const navigationDirection = prevOrNext;
    this.nextOrPreviousImage.emit(navigationDirection);

  }

  /**
   * close Image Viewer
   */
  public closeImageViewer() {
    this.xButtonClicked.emit();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/setup/customer/commodity/commodity-skuImage-accordian/full-view-img-viewer/full-view-img-viewer.component.ts